import { render } from "./RequestGraphics.vue?vue&type=template&id=3722ca6c"
import script from "./RequestGraphics.vue?vue&type=script&lang=js"
export * from "./RequestGraphics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__